import { Box } from '@mui/material'
import React from 'react'
import styles from "./automatedNote.module.css";
import AutomatedNoteSection from '../../Components/updateApplicationAnalysisResultPopup/noteTable/automatedNoteSection';
import { DevPortalAutomatedNotes } from '../../Models/applicationModels';

interface IAutomatedNotesProps {
    automatedNotesData: DevPortalAutomatedNotes;
}

const AutomatedNotes = (props: IAutomatedNotesProps) => {

    const {
        genericNotes,
        threePsAssessmentFactors,
        threePsCategorizedCodes,
        lnidDeclineDetails,
        declineQuestionDetails,
        rtuQuestionDetails,
        applicationProgressDetails,
        rateClassChangeLog,
    } = props.automatedNotesData ?? {};

    const automatedSections = [
        {
            title: "3Ps Code Details",
            tableData: threePsCategorizedCodes,
            renderCondition: !!threePsCategorizedCodes,
        },
        {
            title: "3Ps Code Details",
            tableData: threePsAssessmentFactors,
            renderCondition: !!threePsAssessmentFactors && !threePsCategorizedCodes,
            isObjectList: true,
        },
        {
            title: "Lnid Decline Details",
            tableData: lnidDeclineDetails,
            renderCondition: !!lnidDeclineDetails,
        },
        {
            title: "Decline Details",
            tableData: declineQuestionDetails,
            renderCondition: !!declineQuestionDetails,
        },
        {
            title: "RTU Question Details",
            tableData: rtuQuestionDetails,
            renderCondition: !!rtuQuestionDetails,
        },
        {
            title: "Application Progress Details",
            tableData: applicationProgressDetails,
            renderCondition: !!applicationProgressDetails,
        },
        {
            title: "Rate Class Details",
            tableData: rateClassChangeLog,
            renderCondition: !!rateClassChangeLog && rateClassChangeLog.length > 0,
        },
    ];


    return (
        <Box className={styles.questionsOuter}>
            <Box className={styles.automatedNoteMainSection}>
                {genericNotes &&
                    <>
                        <p className={styles.noteHeader}>{"Automated Notes"}</p>
                        <ul className={styles.genericNoteItemStyle}>
                            <li className={styles.listItemStyle}>
                                {genericNotes}
                            </li>
                        </ul>
                    </>
                }

                {automatedSections.map((section, _) => {
                    if (!section.renderCondition) return null;

                    if (section.isObjectList) {
                        return (
                            <Box className={styles.questionsOuter} key={section.title}>
                                <Box className={styles.automatedNoteSection}>
                                    <p className={styles.noteHeader}>{section.title}</p>
                                    <ul className={styles.listStyle}>
                                        {Object.entries(section.tableData ?? {}).map(([key, value]: [string, string]) => (
                                            <li className={styles.listItemStyle} key={key}>
                                                {`${key} : ${value}`}
                                            </li>
                                        ))}
                                    </ul>
                                </Box>
                            </Box>
                        );
                    }

                    return (
                        <AutomatedNoteSection
                            key={section.title}
                            title={section.title}
                            tableData={section.tableData}
                        />
                    );
                })}
            </Box>
        </Box>
    )
}

export default AutomatedNotes